// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lNsQB","tabListWrap":"HJ_TQe","tablist":"_3ZnBhe","tab":"tLxGNC","selected":"_3VbCp2","tabpannel":"H5kUZC","selectedTabPanel":"yeuCMv"};